export const uniquePredicate = (
  value: string | number,
  index: number,
  array: (string | number)[],
) => {
  return array.indexOf(value) === index;
};
